import { render } from "./PillarsEquity.vue?vue&type=template&id=99835ba0"
import script from "./PillarsEquity.vue?vue&type=script&lang=js"
export * from "./PillarsEquity.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__